export default __webpack_public_path__ + "static/media/nms_logo_colour.809321d1.svg";